import { useEffect, useState } from "react";
import { api } from "../../../lib/api";

export default function AuditAdmin() {
    const [logs, setLogs] = useState(null);

    useEffect(() => {
        api.get("/admin/audit").then((r) => setLogs(r.data)).catch(() => setLogs([]));
    }, []);

    if (!logs) return <p className="text-slate-500">Loading audit log…</p>;

    return (
        <div data-testid="admin-audit">
            <p className="text-sm text-slate-500 mb-4">Every staff action in the portal is recorded here (latest 300).</p>
            <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100" data-testid="admin-audit-list">
                {logs.length === 0 && <p className="p-6 text-sm text-slate-400">No activity recorded yet.</p>}
                {logs.map((l) => (
                    <div key={l.id} className="flex items-center gap-4 p-3.5 text-sm" data-testid={`audit-row-${l.id}`}>
                        <span className="text-xs text-slate-400 w-40 shrink-0">{new Date(l.at).toLocaleString("en-GB")}</span>
                        <span className="font-bold text-slate-700 w-44 truncate shrink-0">{l.actor}</span>
                        <span className="rounded-full bg-slate-100 text-slate-600 text-xs font-bold px-2.5 py-0.5 shrink-0">{l.action}</span>
                        <span className="text-slate-500 truncate">{l.entity} {l.entity_id?.slice(0, 8)} {l.detail && `· ${l.detail}`}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
